import { components } from 'react-select'
import React from 'react'
import { spacing, Text } from '@retailer-platform/shared-components'
import { startCase } from 'lodash'
import { Divider } from '../../../utils/common.styles.tsx'
import { presetDetails } from '../util/qualityAuditWorkflowConfigPresetDetails.tsx'

export const QualityAuditWorkflowConfigPresetOption = (
  props: any | { data: { label: string; value: string } } | undefined
) => {
  const data = props?.data
  const featureDetails = presetDetails?.[data?.label]
  if (!featureDetails) return null
  return (
    <>
      <components.Option {...props}>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            gap: `${spacing.X8}`,
          }}
        >
          <Text
            size={'small'}
            weight={'semibold'}
            css={{
              paddingRight: `${spacing.X16}`,
              marginRight: `${spacing.X16}`,
            }}
          >
            {startCase((data?.label ?? '').toLowerCase())}
          </Text>
          <Text size={'small'} weight={'regular'}>
            {featureDetails.shortDescription}
          </Text>
        </div>
      </components.Option>
      <Divider />
    </>
  )
}
